import { HeroCarousel } from '@/components/home/HeroCarousel/HeroCarousel';

export const HeroSection = () => {
  return <HeroCarousel />;
};
